import axios from "axios";
import { message as AntdAlert } from "antd";
import { put, takeEvery } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";
import * as constants from "../constants";

const url = `${baseURL}/api/v2/super-admin/tenants`;

export function* handleFetchAllTenants({ data }) {
  const { search, ...rest } = data;
  Object.keys(search).forEach((key) => {
    if (search[key]?.length < 1 || search[key] === null) delete search[key];
  });

  try {
    const response = yield axios.get(`${url}`, {
      params: {
        ...rest,
        ...(Object.keys(search).length > 0 && {
          ...search,
        }),
      },
    });
    const { success } = response.data;
    if (success) {
      yield put(actions.fetchAllTenantsSuccess(response.data.data));
    } else if (!success) {
      errorHandler(response.data);
      yield put(actions.fetchAllTenantsError());
    }
  } catch ({ response }) {
    yield put(actions.fetchAllTenantsError());
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleCreateTenant({ data }) {
  try {
    const fd = new FormData();

    for (const key in data) {
      if (data[key]) {
        if (key === "sources") {
          data[key].forEach((source) => {
            fd.append("sources[]", source);
          });
        } else if (key === "type") {
          fd.append("type", data[key]);
        } else {
          fd.append(key, data[key]);
        }
      }
    }

    const response = yield axios.post(`${url}`, fd, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
    const { message } = response.data;
    if (response.data?.data?.tenant) {
      AntdAlert.success(message);
      yield put(actions.createTenantSuccess(response.data?.data?.tenant));
    }
    // else if (!success) {
    //   AntdAlert.error(response.data?.errors[0]);
    //   yield put(actions.createTenantError());
    //   errorHandler(response.data);
    // }
  } catch (error) {
    yield put(actions.createTenantError());
    AntdAlert.error(error?.response?.data?.message || "Something went wrong!");
    console.log(error);
  }
}

export function* handleUpdateTenant({ data }) {
  try {
    const { id, ...res } = data;

    const fd = new FormData();

    for (const key in res) {
      if (res[key]) {
        if (key === "sources") {
          res[key].forEach((source) => {
            fd.append("sources[]", source);
          });
        } else if (key === "type") {
          fd.append("type", res[key]);
        } else {
          fd.append(key, res[key]);
        }
      }
    }

    const response = yield axios.put(`${url}/${id}`, fd, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
    // const { success, message } = response.data;
    if (response.data?.data?.tenant) {
      AntdAlert.success("Tenant updated successfully!");
      const { tenant } = response.data.data;
      yield put(actions.updateTenantSuccess(tenant));
    }
    // else if (!success) {
    //   AntdAlert.error(response.data?.errors[0]);
    //   yield put(actions.updateTenantError());
    //   errorHandler(response.data);
    // }
  } catch (error) {
    yield put(actions.updateTenantError());
    AntdAlert.error(error?.response?.data?.message || "Something went wrong!");
    console.log(error);
  }
}

export function* handleDeleteTenant({ data }) {
  try {
    const response = yield axios.delete(`${url}/${data._id}`);
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.deleteTenantSuccess(response.data.data.tenant));
    } else if (!success) {
      errorHandler(response.data);
      yield put(actions.deleteTenantError(response.data.data.tenant));
    }
  } catch ({ response }) {
    yield put(actions.deleteTenantError());
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleFetchTenant({ data }) {
  try {
    const response = yield axios.get(`${url}/fetch-by-id/${data}`);

    if (response.data?.data?.tenant) {
      // const { permissions, ...res } = response.data.data;
      yield put(actions.fetchTenantSuccess(response.data.data));
    } else {
      yield put(actions.updateTenantError());
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.updateTenantError());
    console.log(error?.response?.data?.message || "Something went wrong!");
  }
}

export function* watcherTenantsSaga() {
  yield takeEvery(constants.FETCH_ALL_TENANTS, handleFetchAllTenants);
  yield takeEvery(constants.CREATE_TENANT, handleCreateTenant);
  yield takeEvery(constants.UPDATE_TENANT, handleUpdateTenant);
  yield takeEvery(constants.FETCH_TENANT, handleFetchTenant);
  yield takeEvery(constants.DELETE_TENANT, handleDeleteTenant);
}
